/* Fithome: galería en tarjeta de producto + botón Añadir a mi cesta (snippets/fh-card-gallery.liquid).
   Añade a la cesta sin salir de la página (todas las opciones, también "Incluido"), actualiza el
   contador de la cesta y muestra el mismo mensaje de arriba que al añadir desde la ficha
   (.toast de sections/header.liquid, mismo texto y mismos tiempos que en layout/theme.liquid). */
(function () {
  if (window.__fhCardGallery) return;
  window.__fhCardGallery = true;

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function currentIndex(track) {
    return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
  }
  function updateBar(root) {
    if (!root) return;
    var track = root.querySelector('.fh-cg__track');
    var bar = root.querySelector('.fh-cg__bar span');
    if (track && bar) bar.style.transform = 'translateX(' + currentIndex(track) * 100 + '%)';
  }
  function closeChooser(root) {
    root.classList.remove('is-choosing');
    var openBtn = root.querySelector('[data-fh-cg-open]');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  }
  function flash(root, label, text) {
    if (!label || !text) return;
    if (!label.hasAttribute('data-label')) label.setAttribute('data-label', label.textContent.trim());
    label.textContent = text;
    clearTimeout(label.__fhTimer);
    label.__fhTimer = setTimeout(function () { label.textContent = label.getAttribute('data-label'); }, 2200);
  }
  function updateCartBubble(sections) {
    var html = sections && sections['cart-icon-bubble'];
    var el = document.getElementById('cart-icon-bubble');
    if (!html || !el) return;
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var s = doc.querySelector('.shopify-section');
      el.innerHTML = s ? s.innerHTML : html;
    } catch (err) {}
  }

  /* Mismo mensaje que la ficha de producto (layout/theme.liquid) */
  var toastTimer = null;
  function showToast(title) {
    var toast = document.querySelector('.toast');
    if (!toast) return false;
    var body = toast.querySelector('.toast-body') || toast;
    body.innerHTML = '';
    var b = document.createElement('b');
    b.textContent = title || '';
    body.appendChild(b);
    body.insertAdjacentHTML('beforeend', ' have been added to <b>shopping bag</b>');
    var $ = window.jQuery;
    clearTimeout(toastTimer);
    if ($) {
      $(toast).stop(true, true).css({ opacity: '', transform: 'translateY(20px)' }).fadeIn(500).animate({ transform: 'translateY(0)' }, 300);
      toastTimer = setTimeout(function () { $(toast).fadeOut(500); }, 5000);
    } else {
      toast.style.opacity = '';
      toast.style.display = 'block';
      toastTimer = setTimeout(function () { toast.style.display = 'none'; }, 5000);
    }
    return true;
  }

  function addToCart(root, variantId, source) {
    var label = root.querySelector('.fh-cg__btn');
    if (source) source.classList.add('is-loading');
    if (label) label.classList.add('is-loading');
    fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: ['cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (source) source.classList.remove('is-loading');
        if (label) label.classList.remove('is-loading');
        closeChooser(root);
        if (!res.ok) {
          flash(root, label, root.getAttribute('data-error'));
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            try { window.publish(window.PUB_SUB_EVENTS.cartError, { source: 'fh-card-gallery', productVariantId: variantId, errors: res.d.description, message: res.d.message }); } catch (err) {}
          }
          return;
        }
        updateCartBubble(res.d.sections);
        if (!showToast(root.getAttribute('data-title'))) flash(root, label, root.getAttribute('data-added'));
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'fh-card-gallery', productVariantId: variantId, cartData: res.d }); } catch (err) {}
        }
      })
      .catch(function () {
        if (source) source.classList.remove('is-loading');
        if (label) label.classList.remove('is-loading');
        flash(root, label, root.getAttribute('data-error'));
      });
  }

  function choose(root, btn) {
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
    addToCart(root, btn.getAttribute('data-variant-id'), btn);
  }

  var pending = false;
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('fh-cg__track') || pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; updateBar(t.closest('[data-fh-cg]')); });
  }, true);

  /* Al quitar el ratón de la foto: se cierra el selector y se quita el foco para que todo desaparezca */
  document.addEventListener('mouseleave', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('fh-cg')) return;
    closeChooser(t);
    t.classList.remove('is-kbd');
    if (document.activeElement && t.contains(document.activeElement)) document.activeElement.blur();
  }, true);

  /* Navegación con teclado (Tab): muestra los controles solo en ese caso */
  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Tab') return;
    document.querySelectorAll('.fh-cg.is-kbd').forEach(function (r) { r.classList.remove('is-kbd'); });
    var a = document.activeElement;
    var r = a && a.closest && a.closest('.fh-cg');
    if (r) r.classList.add('is-kbd');
  });

  /* El formulario de la tarjeta nunca se envía de verdad: se añade por AJAX */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-fh-cg-form')) return;
    e.preventDefault();
    e.stopPropagation();
    var root = form.closest('[data-fh-cg]');
    var single = form.querySelector('[data-fh-cg-single]');
    if (root && single) choose(root, single);
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var el = e.target.closest('[data-fh-cg-nav],[data-fh-cg-open],[data-fh-cg-close],[data-fh-cg-pick],[data-fh-cg-single]');
    if (!el) return;
    var root = el.closest('[data-fh-cg]');
    if (!root) return;
    e.preventDefault();
    e.stopPropagation();

    if (el.hasAttribute('data-fh-cg-nav')) {
      var track = root.querySelector('.fh-cg__track');
      var n = track.children.length;
      if (n < 2) return;
      var i = currentIndex(track) + parseInt(el.getAttribute('data-fh-cg-nav'), 10);
      if (i < 0) i = n - 1;
      if (i >= n) i = 0;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    } else if (el.hasAttribute('data-fh-cg-open')) {
      root.classList.add('is-choosing');
      el.setAttribute('aria-expanded', 'true');
    } else if (el.hasAttribute('data-fh-cg-close')) {
      closeChooser(root);
    } else {
      choose(root, el);
    }
  });

  /* Colección (ordenador): alinea el último icono de vista con el borde derecho de la última foto
     de la fila. Mide en pantalla y desplaza la línea de los iconos. */
  function alignViewIcons() {
    var heads = document.querySelectorAll('.product-count__text');
    if (!heads.length) return;
    heads.forEach(function (h) { h.style.transform = ''; });
    var grid = document.getElementById('product-grid');
    if (!grid || window.innerWidth < 990) return;
    var items = Array.prototype.filter.call(grid.children, function (c) {
      return c.classList && c.classList.contains('grid__item') && c.getBoundingClientRect().width > 0;
    });
    if (!items.length) return;
    var top = items[0].getBoundingClientRect().top;
    var right = 0, moreRows = false;
    items.forEach(function (it) {
      var r = it.getBoundingClientRect();
      if (Math.abs(r.top - top) < 2) right = Math.max(right, r.right);
      else moreRows = true;
    });
    if (!moreRows) {
      var gr = grid.getBoundingClientRect();
      var pr = parseFloat(getComputedStyle(grid).paddingRight) || 0;
      right = gr.right - pr;
    }
    if (!right) return;
    heads.forEach(function (h) {
      if (!h.offsetParent) return;
      var svgs = h.querySelectorAll('.grid-icon svg');
      var last = svgs[svgs.length - 1];
      if (!last) return;
      var d = last.getBoundingClientRect().right - right;
      if (Math.abs(d) > 0.5) h.style.transform = 'translateX(' + (-d).toFixed(1) + 'px)';
    });
  }
  var alignQueued = false;
  function queueAlign() {
    if (alignQueued) return;
    alignQueued = true;
    requestAnimationFrame(function () { alignQueued = false; alignViewIcons(); });
  }
  window.addEventListener('resize', queueAlign);
  window.addEventListener('load', queueAlign);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queueAlign);
  else queueAlign();
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.svg-icon[data-column]')) {
      setTimeout(queueAlign, 50);
      setTimeout(queueAlign, 400);
    }
  });
  setTimeout(queueAlign, 800);
  setTimeout(queueAlign, 2000);
  var gc = document.getElementById('ProductGridContainer');
  if (gc && gc.parentNode && window.MutationObserver) {
    new MutationObserver(function (list) {
      for (var k = 0; k < list.length; k++) {
        var t = list[k].target;
        if (t && t.id !== 'ProductCount' && t.id !== 'ProductCountDesktop') { queueAlign(); break; }
      }
    }).observe(gc.parentNode, { childList: true, subtree: true });
  }
})();
